





























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { getTagCategory, addTag } from '@/api/files/files-base/filesBase'
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'tag-group'
})
export default class extends Vue {
  @Prop({ required: true }) tags!: Array<any>
  private addParams = {
    id: 0,
    name: '',
    category: 1,
    picPath: ''
  }
  private addFormVisible: boolean = false
  private rules: any = {
    name: [{ required: true, message: '请输入角标名', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  private cateList: ISelectItem[] = []
  private tagList: any[] = []
  // lifecycle
  // methodss
  async getTagCategory() {
    let res = await getTagCategory()
    this.cateList = res.data
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(async valid => {
      if (valid && this.addParams.picPath) {
        let res: any = await addTag({
          id: this.addParams.id,
          name: this.addParams.name,
          category: this.addParams.category,
          picPath: this.addParams.picPath.split(domain).pop() as string
        })
        if (res.status.code === 0) {
          this['$message'].success('角标添加成功')
          this.tags.push(res.data)
          this.$emit('update:dynamic-tags', this.tags)
          this.addFormVisible = false;
          (this.$refs['addParams'] as Form).resetFields()
          this.addParams.picPath = ''
        } else {
          this['$message'].error('角标添加失败')
        }
      } else {
        this['$message'].warning('请填写完成后再提交')
        return false
      }
    })
  }

  handleClose(tag: any) {
    console.log(tag)
    for (let i = 0; i < this.tags.length; i++) {
      if (this.tags[i].id === tag.id) {
        this.tags.splice(i, 1)
      }
    }
    this.$emit('update:dynamic-tags', this.tags)
  }

  showAdd() {
    this.addFormVisible = true
    this.getTagCategory()
  }

  handleFormClose() {
    this.addParams.name = ''
    this.addParams.category = 1
    this.addParams.picPath = ''
  }
}
